import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ORDER_TEMPLATES_CHANGED';

let templates = [];

const OrderTemplatesStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  onGetOrderTemplatesSuccess(payload) {
    templates = payload;
    this.emitChange();
  },

  getTemplates() {
    return templates;
  },

});

OrderTemplatesStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.FETCH_ORDER_TEMPLATES_SUCCESS:
      OrderTemplatesStore.onGetOrderTemplatesSuccess(action.templates);
      break;
    default:
      break;
  }
});

export default OrderTemplatesStore;
